/**
 * CF-7 — Credential Fabric awareness (secret-free).
 * Soft≠Live Page203: hooks accept seat flags so sealed buses skip invent calls.
 * Paths are literal until the contract manifest lists them.
 */
import { api, useApi, useAction } from "./api.js";

const STATUS = "/credential-fabric/status";
const RECEIPTS = "/credential-fabric/receipts";
const ROTATION = "/credential-fabric/rotation/preview";

function shapeError(err) {
  const msg = String((err && err.message) || err || "");
  const status = Number((msg.match(/^(\d{3})\b/) || [])[1]) || 0;
  if (status === 404) {
    return { armed: false, message: "Fabric awareness is not registered on this deployment." };
  }
  if (status === 403) {
    return { armed: true, forbidden: true, message: "Staff capability required (SA AI admin)." };
  }
  return { armed: true, message: msg || "Fabric status did not answer." };
}

/** @param {boolean} [armed=true] when false skip Live fetch (Soft invent closed). */
export function useFabricStatus(armed = true) {
  const r = useApi(armed ? STATUS : "");
  if (!armed) {
    return {
      status: null,
      loading: false,
      error: "",
      forbidden: false,
      armed: false,
      reload: r.reload,
    };
  }
  if (r.error) {
    const s = shapeError(r.error);
    return {
      status: null,
      loading: r.loading,
      error: s.message,
      forbidden: !!s.forbidden,
      armed: s.armed !== false,
      reload: r.reload,
    };
  }
  return {
    status: r.data || null,
    loading: r.loading,
    error: "",
    forbidden: false,
    armed: true,
    reload: r.reload,
  };
}

/** @param {boolean} [armed=true] */
export function useFabricReceipts(armed = true) {
  const r = useApi(armed ? RECEIPTS + "?limit=40" : "");
  if (!armed) {
    return {
      receipts: [],
      note: "",
      loading: false,
      error: "",
      armed: false,
      reload: r.reload,
    };
  }
  if (r.error) {
    const s = shapeError(r.error);
    return {
      receipts: [],
      note: s.message,
      loading: r.loading,
      error: s.message,
      reload: r.reload,
    };
  }
  return {
    receipts: (r.data && r.data.receipts) || [],
    note: (r.data && r.data.note) || "",
    armed: !!(r.data && r.data.armed),
    loading: r.loading,
    error: "",
    reload: r.reload,
  };
}

export function useFabricRotation() {
  const action = useAction();
  return {
    busy: action.busy,
    error: action.error,
    async preview() {
      return action.run(ROTATION, { method: "POST", body: {} });
    },
  };
}

export { api };
